import React, { useEffect, useState } from 'react'
import { Card, CardBody, CardHeader, Col, Container, Row } from 'shards-react'
import { formatNumberAmount } from '../../../utils/general'
import { setDateForTable } from '../../../utils/date'
import { useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom.min'
import { connect } from 'react-redux'
import { get_client_invoice_payment_gateway } from '../../../redux/actions/client/clientInvoice'
import { NavgationPageLocationKey } from '../../../utils/constants'
import logoPhrbo from '../../../images/logo_phrbo.svg'

const PaymentGateway = ({ get_client_invoice_payment_gateway }) => {
    const location = useLocation();
    const history = useHistory();
    const [initialState, setInitialState] = useState({
        refNum: 0,
        clientName: "",
        currency: '',
        paymentAmount: 0,
        customerId: '',
        invoiceRefNum: 0,

        // dueDate: '',
        // invoiceStatus: '',
        // receivedAmount: 0,
        // balanceDue: 0,
        // totalGross: 0,
        // totalTax: 0,
        // totalAmount: 0,
    })

    const [formData, setFormData] = useState(initialState)

    const styles = {
        container: {
            fontFamily: "Public Sans, sans-serif",
            padding: "32px",
            maxWidth: "960px",
            margin: "auto",
            background: "white",
            borderRadius: "16px",
            boxShadow: "0 0 10px rgba(0, 0, 0, 0.05)",
        },
        header: {
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "24px",
        },
        logo: {
            fontSize: "20px",
            fontWeight: "bold",
        },
        company: {
            textAlign: "right",
        },
        email: {
            fontSize: "14px",
            color: "#555",
        },
        billBox: {
            background: "#0071bc",
            borderRadius: "8px",
            padding: "16px",
            color: "white",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "32px",
        },
        label: {
            fontSize: "14px",
            opacity: 0.8,
        },
        name: {
            fontSize: "20px",
            fontWeight: "bold",
        },
        custId: {
            background: "white",
            color: "#0071bc",
            padding: "2px 6px",
            fontSize: "12px",
            borderRadius: "4px",
            marginLeft: "6px",
        },
        amountLabel: {
            fontSize: "14px",
            opacity: 0.8,
            textAlign: "right",
        },
        amountValue: {
            fontSize: "20px",
            fontWeight: "bold",
            textAlign: "right"
        },
        usd: {
            fontSize: "12px",
            background: "#fff",
            borderRadius: "15px",
            padding: '8px',
            color: 'black'
        },
        paymentSection: {
            display: "flex",
            gap: "32px",
        },
        optionList: {
            display: "flex",
            flexDirection: "column",
            gap: "12px",
        },
        paymentOption: (selected) => ({
            border: `1px solid ${selected ? "#0071bc" : "#ccc"}`,
            borderRadius: "5px",
            padding: "12px",
            display: "flex",
            alignItems: "center",
            gap: "10px",
            background: selected ? "#eef5ff" : "#f7f9f9",
            cursor: "pointer",
            position: "relative",
        }),
        subtitle: {
            fontSize: "14px",
            color: "#333",
        },
        arrow: {
            content: '""',
            position: "absolute",
            right: "-16px",
            top: "50%",
            transform: "translateY(-50%)",
            width: "0",
            height: "0",
            borderTop: "12px solid transparent",
            borderBottom: "12px solid transparent",
            borderLeft: "16px solid #0071bc",
        },
        paymentPanel: {
            flex: 2,
            border: "1px solid #eee",
            borderRadius: "4px",
            padding: "24px",
            background: "#fafafa",
        },
        methodBox: {
            border: "1px solid #0071bc",
            borderRadius: "8px",
            padding: "16px",
            background: "white",
            display: "flex",
            alignItems: "center",
            gap: "12px",
            margin: "16px 0",
            position: "relative",
        },
        flag: {
            fontSize: "24px",
        },
        methodInfo: {
            flex: 1,
        },
        checkmark: {
            position: "absolute",
            top: "8px",
            right: "8px",
            fontSize: "18px",
            color: "#0071bc",
        },
        payBtn: {
            padding: "10px 20px",
            border: "1px solid #0071bc",
            borderRadius: "6px",
            background: "white",
            color: "#0071bc",
            fontWeight: "bold",
            cursor: "pointer",
        },
        paymentPanelParagraph: {
            textAlign: "center",
            margin: "0px",
        },
    };
    const [selected, setSelected] = useState("bank");

    const PaymentOption = ({ title, subtitle, selected, onClick }) => (
        <div style={styles.paymentOption(selected)} onClick={onClick}>
            <input type="checkbox" checked={selected} readOnly />
            <div>
                <strong>{title}</strong>
                <div style={styles.subtitle}>{subtitle}</div>
            </div>
            {selected && <div style={styles.arrow}></div>}
        </div>
    );

    useEffect(() => {
        if (location.state !== undefined) {
            //Take from state --> Also Add screnario will fall here
            let passedObj = JSON.parse(location.state?.paymentState);
            setFormData({
                ...formData
                , clientName: passedObj.clientName
                , currency: passedObj.currency
                , customerId: passedObj.customerId
                , paymentAmount: passedObj.paymentAmount
                , refNum: passedObj.refNum
                , invoiceRefNum: passedObj.invoiceRefNum
            });
        }
        else if (localStorage.getItem(NavgationPageLocationKey.clientPaymentGateway) !== null) {
            //Take from local storage 
            let passedObj = JSON.parse(localStorage.getItem(NavgationPageLocationKey.clientPaymentGateway));
            //Set state for same page
            let paymentState = JSON.stringify(passedObj);

            setFormData({
                ...formData
                , refNum: passedObj.refNum
                , clientName: passedObj.clientName
                , currency: passedObj.currency
                , paymentAmount: passedObj.paymentAmount
                , customerId: passedObj.customerId
                , invoiceRefNum: passedObj.invoiceRefNum
            });

            history.push({
                pathname: `/client-payment-gateway`,
                state: { paymentState }
            });
            //history.push(location.pathname, paymentState);
            localStorage.removeItem(NavgationPageLocationKey.clientPaymentGateway);
        }
    }, [])

    const collectMoney = (e) => {
        e.preventDefault();
        get_client_invoice_payment_gateway(formData.refNum);
        history.push({
            pathname: `/client-new-invoices`,
            state: { refNum: formData.invoiceRefNum }
        });
    }

    return (
        <div>

            <div style={styles.container}>
                {/* Header */}
                <div style={styles.header}>
                    <div style={styles.logo}>
                        <img
                            id="main-logo"
                            className={`d-inline-block align-top mr-1`}
                            style={{ maxWidth: "12rem" }}
                            src={logoPhrbo}
                            alt="PHRBO"
                        /></div>
                    <div style={styles.company}>
                        <div className="d-flex flex-row justify-content-between" style={{ fontSize: '30px', fontWeight: 'bold' }}>
                            <label>{formData.clientName}</label>
                        </div>
                        {/* <strong>AirChek</strong> */}
                        {/* <div style={styles.email}>contact@airchek.com</div> */}
                    </div>
                </div>

                {/* Bill To */}
                <div style={styles.billBox}>
                    <div>
                        <div style={styles.label}>Bill To</div>
                        <div style={styles.name}>
                            {formData.clientName} <span style={styles.custId}><i>{formData.customerId}</i></span>
                        </div>
                    </div>
                    <div>
                        <div style={styles.amountLabel}><i>Payment Amount</i></div>
                        <div style={styles.amountValue}>
                            <div style={styles.name}>
                                {formData.paymentAmount} <span style={styles.custId}>{formData.currency}</span>
                            </div>
                            {/* <div>
                                <label>
                                    {formData.paymentAmount}
                                </label>
                                <span style={styles.custId}>
                                    {formData.currency}
                                </span>
                            </div> */}
                        </div>
                    </div>
                </div>

                {/* Payment Options */}
                <div style={styles.paymentSection}>
                    <div style={{ flex: 1 }}>
                        <h3>Payment Options</h3>
                        <div style={styles.optionList}>
                            <PaymentOption
                                title="Bank Transfer"
                                subtitle="Pay From Your Bank"
                                selected={selected === "bank"}
                                onClick={() => setSelected("bank")}
                            />
                            <PaymentOption
                                title="Open Banking"
                                subtitle="Pay From Your Bank"
                                selected={selected === "open"}
                                onClick={() => setSelected("open")}
                            />
                        </div>
                    </div>

                    {/* Right Panel */}
                    <div style={styles.paymentPanel}>
                        <h4>{selected === "bank" ? "Bank Transfer" : "Open Banking"}</h4>
                        <p style={styles.paymentPanelParagraph}>Please hit Pay Now button to Proceed.</p>
                        <div style={styles.methodBox}>
                            <div style={{ margin: '0px auto', textAlign: 'center' }}>
                                <div style={styles.flag}>US</div>
                                <div style={styles.methodInfo}>
                                    <div><i class="fa fa-bank" style={{ fontSize: '24px' }}></i> ACH</div>
                                    <div> {formData.currency} {formData.paymentAmount} </div>
                                </div>
                                <div style={styles.checkmark}>
                                    <i class="fa fa-check-circle" style={{ fontSize: '24px' }}></i>
                                </div>
                            </div>
                        </div>
                        <div style={{ margin: '0px auto', textAlign: 'center' }}>
                            <button style={styles.payBtn} onClick={collectMoney}>Pay Now</button>
                        </div>
                    </div>
                </div>
            </div>
        </div >
    )
}

const mapStateToProps = (state) => ({
})
export default connect(mapStateToProps, {
    get_client_invoice_payment_gateway
})(PaymentGateway)
